var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01145 20.918H19.9893C20.2488 20.9179 20.5038 20.8506 20.7295 20.7224C20.9552 20.5943 21.1438 20.4099 21.2768 20.1871C21.4099 19.9643 21.4829 19.7108 21.4886 19.4513C21.4944 19.1919 21.4328 18.9354 21.3097 18.7069L13.3213 3.87094C12.7546 2.81906 11.2461 2.81906 10.6794 3.87094L2.69098 18.7069C2.56796 18.9354 2.50632 19.1919 2.51209 19.4513C2.51786 19.7108 2.59084 19.9643 2.72389 20.1871C2.85695 20.4099 3.04553 20.5943 3.27121 20.7224C3.49689 20.8506 3.75194 20.9179 4.01145 20.918Z",
    stroke: "#B32318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7306 9.15978L11.9997 14.8785L12.2683 9.16212C12.27 9.12558 12.2642 9.08908 12.2512 9.05486C12.2383 9.02064 12.2185 8.98941 12.1931 8.96308C12.1677 8.93676 12.1372 8.91589 12.1035 8.90176C12.0697 8.88762 12.0335 8.88052 11.9969 8.88087C11.961 8.88122 11.9255 8.88877 11.8925 8.90307C11.8595 8.91737 11.8297 8.93814 11.8049 8.96413C11.7801 8.99013 11.7607 9.02084 11.748 9.05444C11.7352 9.08804 11.7293 9.12386 11.7306 9.15978Z",
    stroke: "#B32318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6211C11.8146 18.6211 11.6333 18.5661 11.4792 18.4631C11.325 18.3601 11.2048 18.2137 11.1339 18.0424C11.0629 17.8711 11.0443 17.6826 11.0805 17.5007C11.1167 17.3188 11.206 17.1518 11.3371 17.0207C11.4682 16.8896 11.6352 16.8003 11.8171 16.7641C11.999 16.7279 12.1875 16.7465 12.3588 16.8175C12.5301 16.8884 12.6765 17.0086 12.7795 17.1627C12.8825 17.3169 12.9375 17.4982 12.9375 17.6836C12.9375 17.9322 12.8387 18.1707 12.6629 18.3465C12.4871 18.5223 12.2486 18.6211 12 18.6211Z",
    fill: "#B32318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.ea34beb8f12bee576834727eef7de5d1.svg";
export { ForwardRef as ReactComponent };